export class ColorGenerator {
  static generateClusterColors(count: number): Map<number, string> {
    const colors = new Map<number, string>();

    for (let i = 0; i < count; i++) {
      const hue = (i * 360) / count;
      const saturation = 65;
      const lightness = 70;

      colors.set(i, `hsl(${hue}, ${saturation}%, ${lightness}%)`);
    }

    return colors;
  }

  static getDistinctColor(index: number, total: number): string {
    const hue = (index * 360) / total;
    return `hsl(${hue}, 65%, 70%)`;
  }

  static interpolateColor(color1: string, color2: string, t: number): string {
    const c1 = this.parseHSL(color1);
    const c2 = this.parseHSL(color2);

    if (!c1 || !c2) return color1;

    const h = c1.h + (c2.h - c1.h) * t;
    const s = c1.s + (c2.s - c1.s) * t;
    const l = c1.l + (c2.l - c1.l) * t;

    return `hsl(${Math.round(h)}, ${Math.round(s)}%, ${Math.round(l)}%)`;
  }

  private static parseHSL(
    color: string
  ): { h: number; s: number; l: number } | null {
    const match = color.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
    if (!match) return null;

    return {
      h: parseInt(match[1], 10),
      s: parseInt(match[2], 10),
      l: parseInt(match[3], 10)
    };
  }
}
